import React, { useState } from 'react'
import moment from 'moment'

import { DateRange } from 'react-date-range'

import BaseModal from '../BaseModal'
import ButtonPrimary from '../ui/ButtonPrimary'
import ButtonTransparent from '../ui/ButtonTransparent'

import './index.css'

const DatePicker = (props) => {
  const [ range, setRange ] = useState({
    label: 'Today',
    startDate: moment(),
    endDate: moment(),
  })

  const handleSelect = (range) => {
    setRange({ ...range, label: `${range.startDate.format('MM/DD')} - ${range.endDate.format('MM/DD')}` })
  }

  const fastSelect = (when) => {
    let date
    switch (when) {
      case 'Yesterday':
      default:
        date = {
          startDate: moment().subtract(1, 'days'),
          endDate: moment().subtract(1, 'days'),
        }
        break
      case 'Today':
        date = {
          startDate: moment(),
          endDate: moment(),
        }
        break
      case 'Tomorrow':
        date = {
          startDate: moment().add(1, 'days'),
          endDate: moment().add(1, 'days'),
        }
        break
      case 'last 7 days':
        date = {
          startDate: moment().subtract(7, 'days'),
          endDate: moment(),
        }
        break
      case 'last month':
        date = {
          startDate: moment().subtract(1, 'months'),
          endDate: moment(),
        }
        break
    }
    props.onSelect(date)
  }

  const onApply = () => {
    props.onConfirm(range)
  }

  const createDateForReports = () => {

  }

  const body = (
    <div className="date-picker__body">
      <DateRange
        startDate={props.startDate}
        endDate={props.endDate}
        onChange={handleSelect}
      />
      <div className="date-picker__fast-select fast-select">
        <p className="fast-select__title">Fast Select</p>
        <ul className="fast-select__list">
          <li className="fast-select__item" onClick={() => fastSelect('Yesterday')}>Yesterday</li>
          <li className="fast-select__item" onClick={() => fastSelect('Today')}>Today</li>
          <li className="fast-select__item" onClick={() => fastSelect('Tomorrow')}>Tomorrow</li>
          <li className="fast-select__item" onClick={() => fastSelect('last 7 days')}>last 7 days</li>
          <li className="fast-select__item" onClick={() => fastSelect('last month')}>last month</li>
        </ul>
      </div>
    </div>
  )

  const footer = (
    <div className="date-picker__footer">
      <ButtonPrimary onClick={onApply} name={'Apply'} />
      <ButtonTransparent onClick={props.onClear} name={'Clear'} />
    </div>
  )

  const footerForReports = (
    <div className="date-picker__footer">
      <ButtonPrimary onClick={createDateForReports} name={'View Report'} />
    </div>
  )

  return (
    <BaseModal
      onClose={props.onClose}
      body={body}
      footer={footer}
    />
  )
}

export default DatePicker
